import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isNil } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class BuildingAlarmCardService {
  public buildingAlarmCardUpdated$: BehaviorSubject<BuildingAlarmCardState> = new BehaviorSubject<BuildingAlarmCardState>({
    connectionObjectNumber: '',
    isExpanded: false,
  });
  public buildingAlarmCardStates: BuildingAlarmCardState[] = [];
  public animationToggle = true;

  public expandBuildingAlarm(connectionObjectNumber: string): void {
    this.updateInternalState(connectionObjectNumber, true);
    this.emit(connectionObjectNumber);
  }

  public collapseBuildingAlarm(connectionObjectNumber: string): void {
    this.updateInternalState(connectionObjectNumber, false);
    this.emit(connectionObjectNumber);
  }

  private togglePanelAnimation() {
    this.animationToggle = false;
    setTimeout(() => {
      this.animationToggle = true;
    }, 1000);
  }

  public expandAll(connectionObjectNumbers: string[]): void {
    this.togglePanelAnimation();
    this.buildingAlarmCardStates = connectionObjectNumbers.map((connectionObjectNumber: string) => {
      return {
        connectionObjectNumber,
        isExpanded: true,
      };
    });
    this.buildingAlarmCardStates.forEach((state) => this.emit(state.connectionObjectNumber));
  }

  public collapseAll(): void {
    this.togglePanelAnimation();
    this.buildingAlarmCardStates = [];
    this.emit('');
  }

  public isCollapsed(connectionObjectNumber: string): boolean {
    const buildingAlarmState = this.buildingAlarmCardStates.find((state) => state.connectionObjectNumber === connectionObjectNumber && state.isExpanded);
    return buildingAlarmState == null;
  }

  public isExpandedAll(): boolean {
    return this.buildingAlarmCardStates.find((state) => !state.isExpanded) == null;
  }

  private updateInternalState(connectionObjectNumber: string, expand: boolean): void {
    this.saveIfNotExisting(connectionObjectNumber, expand);
    this.buildingAlarmCardStates = this.buildingAlarmCardStates.map((alarmCardState: BuildingAlarmCardState) => {
      return alarmCardState.connectionObjectNumber === connectionObjectNumber
        ? {
            connectionObjectNumber: connectionObjectNumber,
            isExpanded: expand,
          }
        : alarmCardState;
    });
  }

  private saveIfNotExisting(connectionObjectNumber: string, expand: boolean): void {
    const alarmCardState = this.buildingAlarmCardStates.find((state: BuildingAlarmCardState) => state.connectionObjectNumber === connectionObjectNumber);
    if (isNil(alarmCardState)) {
      this.buildingAlarmCardStates.push({
        connectionObjectNumber: connectionObjectNumber,
        isExpanded: expand,
      });
    }
  }

  private emit(connectionObjectNumber: string) {
    const bldgAlarmCard = isNil(connectionObjectNumber)
      ? ({} as BuildingAlarmCardState)
      : (this.buildingAlarmCardStates.find((state) => state.connectionObjectNumber === connectionObjectNumber) as BuildingAlarmCardState);

    this.buildingAlarmCardUpdated$.next(bldgAlarmCard);
  }
}

export interface BuildingAlarmCardState {
  connectionObjectNumber: string;
  isExpanded: boolean;
}
